import logo_18plus from '../assets/images/18-plus.jpg';
import app_icon from '../assets/images/app-icon.png';
import logo_icon from '../assets/images/logo.png';
import home_icon from '../assets/images/icon-home.png';
import { Link } from 'react-router-dom';
import CommunityModal from './CommunityModal';
import { useEffect, useState } from 'react';

const Header = () => {
  const [isShowCommModal, setShowCommModal] = useState<boolean>(false);
  const [isShowMenuMobile, setShowMenuMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      let fontSize = 16;
      if (window.innerWidth <= 768) {
        fontSize = window.innerWidth / 48;
      }
      document.documentElement.style.fontSize = fontSize + 'px';
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className='header' id='header'>
        <div className='tag-18'>
          <img src={logo_18plus} alt='' />
        </div>
        <div className='container mx-auto flex w-full justify-between'>
          <div className='mobile-section'>
            <Link className='app-icon' to='/'>
              <img src={app_icon} alt='TLVLG' />
            </Link>
            <a className='button-play' href='/play-game?utm_source=Website&utm_medium=Homepage-tlvlg&utm_campaign=BR-PN-0000-MF-AR-280522-1000-KP-TQ-BN-ZG-RTS752-button-choingay' target='_blank'></a>
            <a
              className='button-icon button-coins'
              href='https://pay.zing.vn/zalo/products/vlg'
              target='_blank'
              rel='noreferrer noopener'
            ></a>
            <a
              className='button-icon button-community'
              href='https://www.facebook.com/vuonglaogia.zagoo.vn/'
              target='_blank'
            ></a>
            <a
              className='button-icon button-support'
              href='https://hotro.zagoo.vn/#!/login'
              target='_blank'
            ></a>
            <a className='button-icon button-home' href='/'></a>
            <div
              className='button-menu'
              id='header-nav-menu-btn'
              onClick={() => setShowMenuMobile(!isShowMenuMobile)}
            ></div>
          </div>
          <a className='header-logo' href='/'>
            <img src={logo_icon} alt='TLVLG' />
          </a>
          <div className='app-logo'>
            <img src={app_icon} alt='TLVLG' />
          </div>
          <div
            className={`header-menu ${isShowMenuMobile ? 'show' : ''}`}
            id='header-nav-menu'
          >
            <div
              className='header-menu-backdrop'
              onClick={() => setShowMenuMobile(false)}
            ></div>
            <div className='header-menu-wrapper' id='header-menu-wrapper'>
              <a className='header-item icon-home' href='/'>
                <img src={home_icon} alt='TLVLG' />
                <span>Trang Chủ</span>
              </a>
              <Link className='header-item' to='/posts/tin-tuc'>
                Tin Tức - Sự Kiện
              </Link>
              <Link to='/characters' className='header-item'>
                Nhân Vật
              </Link>
              <Link className='header-item' to='/posts/tinh-nang'>
                Tính Năng -<br />
                Hướng Dẫn
              </Link>
              <a
                className='header-item'
                id='community'
                href='#'
                onClick={() => setShowCommModal(true)}
              >
                Cộng Đồng
              </a>
              <a
                className='header-item'
                href='https://hotro.zagoo.vn/#!/login'
                target={'_blank'}
                rel={'noreferrer'}
              >
                Hỗ Trợ
              </a>
              <a
                className='header-item'
                href='https://zagoo.vn/profile'
                target={'_blank'}
                rel={'noreferrer'}
              >
                Tài Khoản
              </a>
            </div>
          </div>
        </div>
      </div>
      <CommunityModal isShow={isShowCommModal} setShow={setShowCommModal} />
    </>
  );
};

export default Header;
